import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../config/app";
import { RouterName } from "../../router";
import { deviceStorage } from "../../utils/devicestorage";

const PublicRouter = (props: any) => {
    const navigate = useNavigate();
    
    useEffect(()=>{
        const token = deviceStorage[config.appStorage].getItem(config.appPackage+'_X_TOKEN')
        const isOnBoarded = localStorage.getItem("recipe_onBoarded");
        if(isOnBoarded !== 'true') {
            navigate(RouterName.ONBOARDING)
            return
        }
        if(token) {
            navigate(RouterName.MAIN)
        }else {
            // navigate(RouterName.LOGIN)
        }
            

    }, [])
    return <>{props.children}</>
}

export default PublicRouter
